export const suklEPoukazMedicalDeviceFrag = `
    id
    code
    name
    nameSupplement
    unitCode
    unitsPerPackage
    reimbursement1
    approvalFlag1
    reimbursement2
    approvalFlag2
    reimbursement3
    approvalFlag3
    reimbursementGroup
    maximumUnits
    usefulLife
    deviceTypeCode
    ageFrom
    ageTo
    glassDesignCodes
`;

export const suklEPoukazCodeListItemFrag = `
    id
    type
    code
    name
    supplement
    sortOrder
    voucherType
`;

export const suklEPoukazApprovalRuleFrag = `
    id
    code
    approvalFlag1
    approvalFlag2
    approvalFlag3
    note
`;
